import { realApi } from './api';

// Lectura, usada por el selector de temporada de todas las pantallas
// (públicas y privadas) y por el listado/detalle de gestión.
export const getTemporadasReal = () =>
  realApi.get('/temporadas?porPagina=200').then((r) => r.datos);

export const getTemporadaReal = (id) =>
  realApi.get(`/temporadas/${encodeURIComponent(id)}`).then((r) => r.datos);

// Participantes, jornadas necesarias y si cabe la vuelta, por modalidad:
// lo que antes calculaba en el navegador RoundRobinTab con MAX_JORNADAS
// hardcodeado ahora lo decide v_competiciones (temporadas.max_jornadas).
export const getModalidadesReal = (temporadaId) =>
  realApi.get(`/temporadas/${encodeURIComponent(temporadaId)}/modalidades`).then((r) => r.datos);

export const crearTemporada = (datos) =>
  realApi.post('/temporadas', datos).then((r) => r.datos);

export const actualizarTemporada = (id, datos) =>
  realApi.patch(`/temporadas/${encodeURIComponent(id)}`, datos);

export const borrarTemporada = (id) =>
  realApi.delete(`/temporadas/${encodeURIComponent(id)}`);

// La decisión de ida y vuelta es por modalidad (competiciones.ida_y_vuelta),
// no global por temporada.
export const actualizarIdaVuelta = (temporadaId, modalidadId, idaYVuelta) =>
  realApi.patch(`/temporadas/${encodeURIComponent(temporadaId)}/competiciones/${modalidadId}`, { idaYVuelta });

// Muestra u oculta la temporada en los selectores. El rol lo decide la API:
// ADMIN afecta a comité, jugador y público; COMITE, a jugador y público.
export const cambiarVisibilidadTemporada = (id, visible) =>
  realApi.patch(`/temporadas/${encodeURIComponent(id)}/visibilidad`, { visible });
